<div class="container mt-4">
  <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
    <h2 class="mb-2">COMPTES UTILISATEURS</h2>
    <button type="button" class="btn btn-primary mb-2" (click)="openCreate()">
      <i class="fa fa-user-plus"></i> Nouveau compte
    </button>
  </div>

  <div class="bg-light p-3 mb-3 rounded d-flex flex-wrap align-items-center accounts-filters">
    <input type="search" class="form-control accounts-search" placeholder="Rechercher par nom ou email"
      [(ngModel)]="search" (ngModelChange)="onSearchChange()">
    <div class="form-check ms-md-3">
      <input class="form-check-input" type="checkbox" id="includeStudents" [(ngModel)]="includeStudents" (change)="load()">
      <label class="form-check-label" for="includeStudents">Afficher les élèves</label>
    </div>
    <div class="form-check ms-md-3">
      <input class="form-check-input" type="checkbox" id="includeDisabled" [(ngModel)]="includeDisabled">
      <label class="form-check-label" for="includeDisabled">Afficher les comptes désactivés ({{ disabledCount }})</label>
    </div>
  </div>

  @if (messageError) {
    <div class="alert alert-danger">{{ messageError }}</div>
  }
  @if (loading) {
    <div class="text-muted"><i class="fa fa-spinner fa-spin"></i> Chargement...</div>
  }

  @if (!loading) {
    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="table-light">
          <tr>
            <th>Utilisateur</th>
            <th>Email</th>
            <th>Type</th>
            <th>Rôles</th>
            <th class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          @if (displayedAccounts.length === 0) {
            <tr>
              <td colspan="5" class="text-muted">Aucun compte trouvé.</td>
            </tr>
          }
          @for (a of displayedAccounts; track a) {
            <tr [class.account-row--disabled]="!a.enabled">
              <td class="fw-bold">{{ a.username }}</td>
              <td>{{ a.email }}</td>
              <td>
                <span class="account-type" [ngClass]="'account-type--' + a.type.toLowerCase()">{{ typeLabel(a) }}</span>
                @if (!a.enabled) {
                  <span class="account-type account-type--disabled ms-1">Désactivé</span>
                }
              </td>
              <td>
                @for (r of a.roles; track r) {
                  <span class="badge text-bg-info me-1">{{ roleLabel(r) }}</span>
                }
                @if (a.roles.length === 0) {
                  <span class="text-muted">Aucun</span>
                }
              </td>
              <td class="text-end text-nowrap">
                @if (a.type !== 'STUDENT') {
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="openRoles(a)">
                    <i class="fa fa-shield"></i> Rôles
                  </button>
                }
                @if (canToggle(a)) {
                  <button type="button" class="btn btn-sm ms-1" (click)="toggleAccount(a)"
                    [ngClass]="a.enabled ? 'btn-outline-danger' : 'btn-outline-success'">
                    <i class="fa" [ngClass]="a.enabled ? 'fa-ban' : 'fa-check'"></i> {{ a.enabled ? 'Désactiver' : 'Activer' }}
                  </button>
                }
                <!-- span : l'infobulle reste visible sur un bouton désactivé -->
                <span class="d-inline-block ms-1" [title]="editTitle(a)">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="openEdit(a)" [disabled]="!canEditAccount(a)">
                    <i class="fa fa-pencil"></i> Modifier
                  </button>
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <p class="text-muted small">
    <i class="fa fa-info-circle"></i> « Modifier » change le compte d'accès (identifiant, email, mot de passe) ; les autres
    informations d'un moniteur ou d'un élève se modifient depuis sa fiche.
    Un compte désactivé ne peut plus se connecter ; un moniteur désactivé est aussi retiré des plannings et de la liste des moniteurs.
    Les changements de rôles sont pris en compte à la prochaine connexion de l'utilisateur.
  </p>
</div>

<!-- Rôles d'un compte -->
<div class="modal fade" id="accountRolesModal" tabindex="-1" role="dialog" aria-labelledby="accountRolesLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="accountRolesLabel"><i class="fa fa-shield"></i> Rôles de {{ rolesAccount?.username }}</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        @if (rolesAccount) {
          <app-user-roles [iEmail]="rolesAccount.email"></app-user-roles>
        }
      </div>
    </div>
  </div>
</div>

<!-- Création / modification d'un compte du personnel -->
<div class="modal fade" id="staffAccountModal" tabindex="-1" role="dialog" aria-labelledby="staffAccountLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form (ngSubmit)="save(f)" #f="ngForm" novalidate>
        <div class="modal-header">
          <h5 class="modal-title" id="staffAccountLabel">
            {{ editedId === null ? 'Nouveau compte' : 'Modifier le compte d\'accès' }}
          </h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          @if (formError) {
            <div class="alert alert-danger py-2">{{ formError }}</div>
          }

          @if (editedId === null) {
            <div class="form-group">
              <label for="accountType">Type de compte</label>
              <select id="accountType" name="accountType" class="form-control" [(ngModel)]="newType" (ngModelChange)="formError = ''">
                <option value="MONITOR">Moniteur (fiche moniteur + compte)</option>
                <option value="STAFF">Personnel (secrétariat...)</option>
              </select>
            </div>
          }

          <!-- Fiche moniteur -->
          @if (editedId === null && newType === 'MONITOR') {
            <fieldset class="monitor-fieldset">
              <legend class="monitor-fieldset__legend">Fiche moniteur</legend>
              <div class="form-group">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="sexe" id="sexeM" value="M" [(ngModel)]="monitorForm.sexe">
                  <label class="form-check-label" for="sexeM">Monsieur</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="sexe" id="sexeF" value="F" [(ngModel)]="monitorForm.sexe">
                  <label class="form-check-label" for="sexeF">Madame</label>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-sm-6">
                  <label for="monitorLastname">Nom</label>
                  <input id="monitorLastname" name="lastname" class="form-control" [(ngModel)]="monitorForm.lastname" required minlength="3" maxlength="50">
                </div>
                <div class="form-group col-sm-6">
                  <label for="monitorFirstname">Prénom</label>
                  <input id="monitorFirstname" name="firstname" class="form-control" [(ngModel)]="monitorForm.firstname" required minlength="3" maxlength="50">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-8">
                  <label for="monitorPhone">Téléphone</label>
                  <input id="monitorPhone" name="phoneNumber" class="form-control" [(ngModel)]="monitorForm.phoneNumber"
                    required pattern="0[0-9]{9}" placeholder="0601020304">
                </div>
                <div class="form-group col-4">
                  <label for="monitorColor">Couleur</label>
                  <input id="monitorColor" name="color" type="color" class="form-control" [(ngModel)]="monitorForm.color">
                </div>
              </div>
            </fieldset>
          }

          <div class="form-group">
            <label for="accountUsername">Nom d'utilisateur (connexion)</label>
            <input id="accountUsername" name="username" class="form-control" [(ngModel)]="form.username" required maxlength="20">
          </div>
          <div class="form-group">
            <label for="accountEmail">Email</label>
            <input id="accountEmail" name="email" type="email" class="form-control" [(ngModel)]="form.email" required email maxlength="50">
          </div>
          <div class="form-group">
            <label for="accountPassword">Mot de passe</label>
            <input id="accountPassword" name="password" type="password" class="form-control" autocomplete="new-password"
              [(ngModel)]="form.password" [required]="editedId === null" minlength="6" maxlength="40"
              [placeholder]="editedId === null ? '6 caractères minimum' : 'Laisser vide pour ne pas le changer'">
          </div>

          @if (editedId === null) {
            <div class="form-group mb-0">
              <label class="d-block">{{ newType === 'MONITOR' ? 'Rôles en plus du rôle Moniteur (facultatif)' : 'Rôles' }}</label>
              @for (role of staffRoles; track role) {
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" [id]="'role-' + role"
                    [checked]="$safeNavigationMigration(form.roles?.includes(role))" (change)="toggleRole(role)">
                  <label class="form-check-label" [for]="'role-' + role">{{ roleLabel(role) }}</label>
                </div>
              }
            </div>
          }
          @if (editedId !== null && editedType !== 'STAFF') {
            <small class="d-block text-muted">
              <i class="fa fa-info-circle"></i> L'email de la fiche {{ editedType === 'MONITOR' ? 'moniteur' : 'élève' }} sera aussi mis à jour.
            </small>
          }
          @if (editedId !== null) {
            <small class="d-block text-muted">Les rôles se gèrent avec le bouton « Rôles ».</small>
          }
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
          <button type="submit" class="btn btn-primary" [disabled]="saving">
            @if (saving) {
              <span class="spinner-border spinner-border-sm"></span>
              } Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
